const COMPANY_NAME = "Tipy Family";

export const COPY = {
  languages: ["pt", "en"],
  pt: {
    agent: "O seu consultor:",
    agency: "A sua agência:",
    content: {
      title: `"Saiba quanto VALORIZOU a sua CASA nos últimos anos"`,
      subTitle:
        "Agência FUNDADORA da marca CENTURY21 em PORTUGAL\nN1 Península Setúbal Faturação\nTop 3 nacional Faturação\n26 anos mercado imobiliário",
    },
    disclaimer:
      "Ao subscrever os serviços disponibilizados por esta plataforma, e consequente consentimento, a Tipy Family procede à recolha e ao tratamento dos dados pessoais necessários à prestação dos serviços de mediação imobiliária e a fornecer informação sobre bens imobiliários e oportunidades de negócios e irá transmitir os dados recolhidos aos consultores imobiliários que compõem a sua rede, exclusivamente para os fins mencionados.",
    notice:
      "Cada agência é jurídica e financeiramente independente Tipy Family - Soc. de Mediação imoliária Lda. | AMI 2482 | FGP LX. Lda. | AMI 16845 | FGSADO Lda. | AMI 17175 | FGM&C LDA | AMI 18194",
  },
  en: {
    agent: "Your agent:",
    agency: "Your agency:",
    content: {
      title: `"Find out HOW MUCH the value of your HOUSE APPRECIATED in the last years"`,
      subTitle:
        "FOUNDING agency of CENTURY 21 Portugal\n#1 in revenue of the Península of Setúbal\nTop 3 in revenue at the national level\n26 years in the real estate market",
    },
    disclaimer:
      "By subscribing and consenting to the services provided by this platform, Tipy Family Group collects and processes all the personal data necessary to provide real estate services, information about the real estate market and business opportunities. Furthermore, it will transmit the this data to real estate consultants that make up its network, exclusively for the aforementioned purposes mentioned.",
    notice:
      "Each agency is legally and financially independent Tipy Family - Soc. de Mediação imoliária Lda. | AMI 2482 | FGP LX. Lda. | AMI 16845 | FGSADO Lda. | AMI 17175 | FGM&C LDA | AMI 18194",
  },
};
